import dompurify from 'dompurify';

export const emailReg =
  /((?:http:\/\/|https:\/\/|sslocal:\/\/)(?:(?:\w|=|\?|\.|\/|&|-|%|@|#)+))/;

export function handleRecognition(htmlStr: string) {
  const fragment = document.createElement('div');
  fragment.innerHTML = dompurify.sanitize(htmlStr, {
    ADD_ATTR: ['target'],
    ALLOWED_URI_REGEXP:
      /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp|xxx|lark|sslocal|aweme):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
  });

  const traverseNodeList = (nodeList: NodeListOf<ChildNode>) => {
    [].forEach.call(nodeList, (node: ChildNode) => {
      if (node.hasChildNodes()) {
        traverseNodeList(node.childNodes);
      } else if (node.nodeType === Node.TEXT_NODE && node.textContent) {
        if (
          emailReg.test(node.textContent) &&
          node.parentNode?.nodeName?.toLocaleLowerCase() !== 'a'
        ) {
          const texts = node.textContent.split(emailReg);
          const fragment = document.createDocumentFragment();
          texts.filter(Boolean).forEach((text) => {
            let node;
            if (emailReg.test(text)) {
              node = document.createElement('a');
              node.setAttribute('href', text);
              node.setAttribute('target', '__blank');
              node.innerHTML = text;
            } else {
              node = document.createTextNode(text);
            }
            fragment.appendChild(node);
          });
          node.replaceWith(fragment);
        }
      }
    });
  };

  traverseNodeList(fragment.childNodes);

  return fragment.innerHTML;
}
